// msw is a devDependency but this file is only used by Storybook, which includes devDependencies in its build
// eslint-disable-next-line import/no-extraneous-dependencies
import { HttpResponse } from 'msw';

/** Seconds the backend asks a client to wait before trying a provider read again. */
const PROVIDER_RETRY_AFTER_SECONDS = '30';

/**
 * The answer a payroll route gives while the provider is down or rate limiting us: 503
 * `PROVIDER_UNAVAILABLE` with a `Retry-After`. Shared by every payroll demo so the stories fail the
 * way the backend does.
 */
const providerUnavailableResponse = () =>
    HttpResponse.json(
        { error: { code: 'PROVIDER_UNAVAILABLE' } },
        { status: 503, headers: { 'Retry-After': PROVIDER_RETRY_AFTER_SECONDS } }
    );

export default providerUnavailableResponse;
